// Demo Admin Helper
// This utility provides functions to enable admin access in demo mode

import { useAuthStore } from '@/store/authStore';
import { demoUser } from '@/services/demoData';
import { toast } from 'react-hot-toast';

/**
 * Enable admin access in demo mode
 * This function modifies the auth store to grant admin access
 */
export const enableDemoAdmin = (): void => {
  const { user, isAuthenticated } = useAuthStore.getState();
  
  // Only works in demo mode with a logged in user
  if (!isAuthenticated || !user) {
    toast.error('Please log in first to enable admin access');
    return;
  }
  
  // Update the user object to include admin privileges
  useAuthStore.setState({
    user: {
      ...user,
      isAdmin: true
    }
  });
  
  toast.success('Admin access enabled! You can now access the admin panel at /admin');
};

/**
 * Check if the current user has admin access
 */
export const isDemoAdmin = (): boolean => {
  const { user, isAuthenticated } = useAuthStore.getState();
  return isAuthenticated && !!user?.isAdmin;
};

/**
 * Demo login with admin privileges
 * This function simulates a login with admin access
 */
export const demoAdminLogin = (): void => {
  // Create a demo admin user based on the demo user
  const adminUser = {
    ...demoUser,
    id: 'demo-admin-id',
    username: 'DemoAdmin',
    isAdmin: true
  };
  
  // Set the auth store state
  useAuthStore.setState({
    user: adminUser,
    isAuthenticated: true,
    isLoading: false,
    error: null,
    token: 'demo-admin-token'
  });
  
  toast.success('Logged in as admin! You can now access the admin panel at /admin');
};

export default {
  enableDemoAdmin,
  isDemoAdmin,
  demoAdminLogin
};